module.exports = __webpack_public_path__ + "static/softball-rendering-866c3694082174b11b7fafd34b3c35b6.jpg";